import { colors } from '@/theme/zeelool.theme';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';

interface ZeeloolCheckboxProps extends CheckboxProps {
  fontSize?: number;
}

const BpIcon = styled('span')<{ fontSize?: number }>(({ fontSize = 16 }) => ({
  borderRadius: 3,
  width: fontSize,
  height: fontSize,
  border: '1px solid #d4d4d4',
  backgroundColor: '#ffffff',
  '.Mui-focusVisible &': {
    outline: `2px auto ${colors.primaryPurpleHover}`,
    outlineOffset: 2,
  },
  // 只在真正支持hover的设备上启用hover效果，避免移动端触摸后显示主题色边框
  '@media (hover: hover)': {
    'input:hover ~ &': {
      borderColor: colors.primaryBlackHover,
    },
  },
  'input:disabled ~ &': {
    borderColor: '#d4d4d4',
    backgroundColor: '#EEEEEE',
    opacity: 0.6,
  },
}));

const BpCheckedIcon = styled(BpIcon)<{ fontSize?: number }>(({ fontSize = 16 }) => ({
  backgroundColor: colors.primaryPurple,
  borderColor: colors.primaryPurple,
  position: 'relative',
  '&::before': {
    display: 'block',
    width: Math.max(fontSize * 0.9, 12), // 对勾大小为容器的90%，最小12px
    height: Math.max(fontSize * 0.9, 12),
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: colors.primaryPurpleHover,
    borderColor: colors.primaryPurpleHover,
  },
}));

// Inspired by blueprintjs
function ZeeloolCheckbox({ fontSize = 16, ...props }: ZeeloolCheckboxProps) {
  return (
    <Checkbox
      sx={{
        '&:hover': { bgcolor: 'transparent' },
        '&.MuiCheckbox-root': {
          padding: 0,
        },
      }}
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon fontSize={fontSize} />}
      icon={<BpIcon fontSize={fontSize} />}
      {...props}
    />
  );
}
export default ZeeloolCheckbox;
export type { ZeeloolCheckboxProps };
